
export function saveToSessionStorage(itemName, item) {
    try {
        const serializedItem = JSON.stringify(item);
        window.sessionStorage.setItem(itemName, serializedItem);
    } catch (err) {
        // swallow errors
    }
}

export function loadFromSessionStorage(itemName) {
    try {
        const serializedItem = window.sessionStorage.getItem(itemName);
        if (serializedItem) {
            return JSON.parse(serializedItem);
        }
    } catch (err) {
        return undefined;
    }
}
